
const ReferralEmailTemplate = (dataFields: any, link: string) => {

  var htmlContent = `<html !DOCTYPE html>

<head>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link
    href="https://fonts.googleapis.com/css2?family=Hanken+Grotesk:ital,wght@0,100..900;1,100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
    rel="stylesheet">
</head>
<style>
  .poppins {
    font-family: 'Poppins', sans-serif;
  }

  .hk-grotesk {
    font-family: 'HK Grotesk', sans-serif;
  }
</style>

<body>
  <center style="padding-top:10px; padding-bottom:10px;">
    <img src="https://netstratum.ncsapp.com/docs/f262c1f6-d236-456f-a9ce-fbfdb8d67741/1730796611247/full.png" alt="pic"/>
  </center>
  <center>
    <img src="https://netstratum.ncsapp.com/docs/f262c1f6-d236-456f-a9ce-fbfdb8d67741/1730796946103/Frame%20316123768.png" alt="pic" style="max-width: 100%; height: auto; display: block;"/>
  </center>
  <table style=" padding-top:20px; width:100%; max-width:600px; margin:auto;">
    <tr>
      <td class="poppins" style="font-weight:700; font-size:36px; line-height:50.4px; color:#273443;">
        Enjoy a vacation with Travelsment and save $200!
      </td>
    </tr>
    <tr>
      <td class="hk-grotesk" style="padding-top:25px; font-weight:500; font-size:20px;">
        Hi ${dataFields[0].value ? dataFields[0].value : `Invitee`},
      </td>
    </tr>
    <tr>
      <td class="hk-grotesk" style="padding-top:25px; font-weight:500; font-size:20px;">
        I think you will enjoy taking a vacation with Travelsment and wanted to invite you to make a booking.
      </td>
    </tr>
    <tr>
      <td class="poppins" style="padding-top:25px; font-weight:700; font-size:18px;">
        Here’s my invitation link to learn more:
      </td>
    </tr>
    <tr>
      <td style="padding-top:10px;">
       <a href=${link}> <button style="background:#0094FF; padding:10px 28px; border-radius:16px; color:white; border:none; font-family:'Poppins', sans-serif; font-weight:700; font-size:14px;">
          Visit Travelsment
        </button></a>
      </td>
    </tr>
  </table>
  <table class="hk-grotesk"
    style=" padding:20px; width:100%; max-width:600px; margin:auto ;margin-top:30px;background-color:#EAEFF4;font-weight:500; font-size:14px;color:#273443; border-radius:16px">
    <tr>
      <td>
      <img src="https://travelsment-dev.s3.amazonaws.com/media/danger-triangle.png" alt='circle'/>
      </td>
    </tr>
    <tr>
      <td style='padding-top:5px'>
        If the button doesn’t work - copy and paste the link below to your browser
      </td>
    </tr>
    <tr>
      <td style='padding-top:5px ;color:#0279CF;font-weight:600px;font-size:16px'>
        <a >${link}</a>
      </td>
    </tr>
  </table>
<div style="width: 100%; background-color: #EAEFF4; padding: 10px; margin-top: 30px; text-align: center;">
<center>
  <center>
    <p class="hk-grotesk" style="color: #758191; font-size: 14px; margin: 0;">
      Visit our Socials
    </p>
  </center>
  <div style="padding-top: 5px; text-align: center;">
    <img 
      src="https://travelsment-dev.s3.amazonaws.com/media/small.png" 
      alt="pic" 
      style="margin: 0 5px; display: inline-block;"
    />
    <img 
      src="https://travelsment-dev.s3.amazonaws.com/media/small1.png" 
      alt="pic" 
      style="margin: 0 5px; display: inline-block;"
    />
    <img 
      src="https://travelsment-dev.s3.amazonaws.com/media/small2.png" 
      alt="pic" 
      style="margin: 0 5px; display: inline-block;"
    />
    <img 
      src="https://travelsment-dev.s3.amazonaws.com/media/small3.png" 
      alt="pic" 
      style="margin: 0 5px; display: inline-block;"
    />
  </div>
  <center style="padding-top: 5px;">
    <p class="hk-grotesk" style="color: #758191; font-size: 14px; margin: 0;">
      ©2022 Travelsment
    </p>
  </center>
  </center>
</div>

  </body>

</html>`
  return htmlContent
}

export default ReferralEmailTemplate;